import {Injectable, Injector, inject} from "@angular/core";
import {SearchModel} from "@fedelta-pos/data-client";
import {OrderTransferTargetData} from "./order-transfer-target-entity.model";

@Injectable()
export class OrderTransferTargetSearchModel extends SearchModel<OrderTransferTargetData> {
    constructor() {
        console.log("--- OrderTransferTargetSearchModel");
        super(inject(Injector), OrderTransferTargetData);
    }

    override getResourceName(): string {
        return "app-order-transfer-target";
    }
}
